export default {
  name: 'NrCard',
  props: {
    hovered: {
      type: Boolean
    },
    faded: {
      type: Boolean,
      default: false
    },
    color: {
      type: String
    },
    active: {
      type: Boolean
    }
  },
  computed: {
    setBoxShadow: function setBoxShadow() {
      return this.hovered ? 'on-hover' : 'no-hover';
    },
    setOpacity: function setOpacity() {
      return this.faded ? 'with-fade' : 'no-fade';
    }
  }
};